export default __webpack_public_path__ + "static/media/roles_5.e5272468.png";